import { render, staticRenderFns } from "./NuevoFiltro.vue?vue&type=template&id=36513a00"
import script from "./NuevoFiltro.vue?vue&type=script&lang=js"
export * from "./NuevoFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports